import { send } from 'server';
import uuid from 'uuid-random';

export const fetchRemainingDepositLimits = () => send({
    ID: 35532,
    description: 'Get Remaining Deposit Limits',
    responses: [35533, 35534],
    limitDescriptions: [
        {
            id: 1,
            type: 'depositlimit',
            period: 'daily'
        },
        {
            id: 2,
            type: 'depositlimit',
            period: 'weekly'
        },
        {
            id: 3,
            type: 'depositlimit',
            period: 'monthly'
        }
    ]
});

export const transferFunds = (amount, currencyCode, internalFundTransferDate) => send({
    ID: 32015,
    description: 'Internal Fund Transfer',
    internalFundTransferCode: uuid(),
    sourceBalanceType: 'retail_deposits_balance',
    targetBalanceType: 'debit_card_deposits_balance',
    internalFundTransferDate,
    amount: {
        amount,
        currencyCode
    },
    responses: [32016, 32017]
});
